import styled from "styled-components";

// ./styled-components
export * from "./styled-components";

// ./types
export * from "./types";

// ./themes
export * from "./themes";

// ./components
export * from "./components";

// ./contexts
export * from "./contexts";

// ./hooks
export * from "./hooks";

// .hoc
export * from "./hoc";

// ./utils
export * from "./utils";

const kitchn = styled;
export default kitchn;
